export function projectSlider() {
	var swiper = new Swiper('.project-slider', {
		direction: 'horizontal',
		speed: 100,
		prevButton: '.swiper-button-prev',
		nextButton: '.swiper-button-next',
	}) // Navigation arrows
}
